import moment from 'moment'

const DATA_PADRAO_BACKEND = '0001-01-01'

/**
 * DateTime não preenchido chega do backend como '0001-01-01T00:00:00' (default do .NET).
 * Para a tela isso é ausência de data, não uma data válida.
 */
export function isDataVazia(valor: any): boolean {
  if (!valor) {
    return true
  }

  return String(valor).startsWith(DATA_PADRAO_BACKEND)
}

/** Normaliza a data do backend para o formato 'YYYY-MM-DD' que o v-date-picker espera. */
export function toDataPicker(valor: any): string | null {
  if (isDataVazia(valor)) {
    return null
  }

  const data = moment(valor)

  return data.isValid() ? data.format('YYYY-MM-DD') : null
}

export function formatHoras(qtdeHoras: number | null | undefined): string {
  if (qtdeHoras === null || qtdeHoras === undefined) {
    return '-'
  }

  const totalMinutos = Math.round(qtdeHoras * 60)
  const horas = Math.floor(totalMinutos / 60)
  const minutos = totalMinutos % 60

  return `${horas}h${minutos.toString().padStart(2, '0')}min (${qtdeHoras})`
}
